// NEW_FILE_JUSTIFIED: Sub-component extracted from ComposeEmail to stay within 200-line limit — renders To/CC/BCC/Subject fields
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import type { IComposeFormFieldsProps } from '@/@types/gmail';

export function ComposeFormFields({
  to,
  setTo,
  cc,
  setCc,
  bcc,
  setBcc,
  subject,
  setSubject,
  showCcBcc,
  toggleCcBcc,
}: IComposeFormFieldsProps) {
  return (
    <>
      <div className="flex items-center gap-2">
        <label htmlFor="compose-to" className="text-sm text-muted-foreground w-12 shrink-0">
          To:
        </label>
        <Input
          id="compose-to"
          value={to}
          onChange={e => setTo(e.target.value)}
          placeholder="recipient@example.com"
          className="flex-1"
          required
          aria-required="true"
        />
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleCcBcc}
          aria-expanded={showCcBcc}
          className="text-xs"
        >
          {showCcBcc ? 'Hide CC/BCC' : 'CC/BCC'}
        </Button>
      </div>

      {showCcBcc && (
        <>
          <div className="flex items-center gap-2">
            <label htmlFor="compose-cc" className="text-sm text-muted-foreground w-12 shrink-0">
              CC:
            </label>
            <Input
              id="compose-cc"
              value={cc}
              onChange={e => setCc(e.target.value)}
              placeholder="cc@example.com"
              className="flex-1"
            />
          </div>
          <div className="flex items-center gap-2">
            <label htmlFor="compose-bcc" className="text-sm text-muted-foreground w-12 shrink-0">
              BCC:
            </label>
            <Input
              id="compose-bcc"
              value={bcc}
              onChange={e => setBcc(e.target.value)}
              placeholder="bcc@example.com"
              className="flex-1"
            />
          </div>
        </>
      )}

      <div className="flex items-center gap-2">
        <label htmlFor="compose-subject" className="text-sm text-muted-foreground w-16 shrink-0">
          Subject:
        </label>
        <Input
          id="compose-subject"
          value={subject}
          onChange={e => setSubject(e.target.value)}
          placeholder="Subject"
          className="flex-1"
          required
          aria-required="true"
        />
      </div>
    </>
  );
}
